module.exports = __webpack_public_path__ + "img/zfb_jia.8d1ae019.png";